import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'digi_quote_page' */ './DigiQuote'),
);
